import styled from "@emotion/styled"
import { NavigateBefore, NavigateNext } from "@mui/icons-material"
import { Grid, Typography } from "@mui/material"
import * as api from "api"
import RatioElement from "common/ElementRatio"
import ResponsiveModelImage from "common/ResponsiveModelImage"
import { memo, useState } from "react"

const Styled = {
  Grid: styled(Grid)`
    background-color: ${(p) => p.theme.colors.paleGrey};
  `,
  GridChild: styled(Grid)`
    flex-direction: column;
    padding: 50px 70px;
    justify-content: space-between;
  `,
  Header: styled(Typography)`
    font-size: 20px;
    color: ${(p) => p.theme.colors.bluishGrey};
  `,
  Title: styled(Typography)`
    margin-top: 10px;
    font-size: 34px;
    font-weight: bold;
    color: ${(p) => p.theme.colors.marine};
  `,
  Description: styled(Typography)`
    margin-top: 20px;
    font-size: 18px;
    color: ${(p) => p.theme.colors.marine};
  `,
  Next: styled(NavigateNext)`
    width: 35px;
    height: 35px;
    border: solid 2px ${(p) => p.theme.colors.marine};
    border-radius: 50%;
    cursor: pointer;
    color: ${(p) => p.theme.colors.marine};
  `,
  Prev: styled(NavigateBefore)`
    width: 35px;
    height: 35px;
    border: solid 2px ${(p) => p.theme.colors.marine};
    border-radius: 50%;
    margin-inline-start: 20px;
    cursor: pointer;
    color: ${(p) => p.theme.colors.marine};
  `,
}

type VehicleGalleryDesktopProps = {
  data: api.VehicleOutInOptionsGallery[]
  type: string
  reverse: boolean
}

const VehicleGalleryDesktop = ({
  data,
  type,
  reverse,
}: VehicleGalleryDesktopProps) => {
  const [current, setCurrent] = useState(0)
  const [selected, setSelected] = useState(data[current])

  const setPrev = () => {
    const idx = current > 0 ? current - 1 : data.length - 1
    setCurrent(idx)
    setSelected(data[idx])
  }

  const setNext = () => {
    const idx = current < data.length - 1 ? current + 1 : 0
    setCurrent(idx)
    setSelected(data[idx])
  }
  const visibility = data.length > 1 ? "visible" : "hidden"

  return (
    <Styled.Grid container direction={reverse ? "row-reverse" : "row"}>
      <Styled.GridChild container item md={6}>
        <Grid item>
          <Styled.Header>מאפיין {type}</Styled.Header>
          <Styled.Title>{selected.name}</Styled.Title>
          <Styled.Description>{selected.description}</Styled.Description>
        </Grid>
        <Grid item>
          <Styled.Next onClick={setNext} visibility={visibility} />
          <Styled.Prev onClick={setPrev} visibility={visibility} />
        </Grid>
      </Styled.GridChild>
      <Grid item md={6}>
        <RatioElement ratio={3 / 2}>
          <ResponsiveModelImage
            image={selected.image}
            cover
            imageSizes="640px"
          />
        </RatioElement>
      </Grid>
    </Styled.Grid>
  )
}

export default memo(VehicleGalleryDesktop)
